import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SearchDoctorappointmentComponent } from '../searchDoctorappointment/search-doctorappointment.component';
import { ModalService } from 'src/modules/base/services/modal.service';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
@Injectable({
  providedIn: 'root'
})
export class DeactivateRouteService  {
  data: boolean = true;

  constructor(
    private modalService: ModalService,
    private permission: RolePermissionService
  ) { }

  canDeactivate(
    component: SearchDoctorappointmentComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> | boolean {
    return (this.data == false && this.permission.checkAccessPermission('popup_exit', 'appointment', 'appointment')) ? this.openpopup() : true;
  }

  openpopup() {
    return new Promise((resolve) => {
      this.modalService.confirmCustomBtn("LEAVE", "There are some unsaved changes , you want to leave this page?", ModalSize.Sm, { cancel: "NO", ok: "YES" }).subscribe(result => {
        resolve(result);
      });
    });
  }
}